import React from 'react';
import { PageTitle } from '../../../common/components/page-title';
import { DocsLayout } from '../../common/components/layout/docs-layout';
import { ERRORS } from '../configs/errors';

export const ErrorsPage = () => (
	<React.Fragment>
		<PageTitle
			title="Documentation"
			linkHref="/explorer"
			linkTitle="API Explorer"
		/>
		<DocsLayout>
			<h2 className="text-4xl mb-2">Error Types</h2>

			{ERRORS.map((error) => (
				<div key={error.title}>
					<h3 className="text-2xl mt-10">
						{error.title}
					</h3>
					<div
						className="mb-2"
						dangerouslySetInnerHTML={{ __html: error.desc || '' }}
					/>
				</div>
			))}

			{/*<h3 className="text-2xl mt-8">List</h3>*/}

		</DocsLayout>
	</React.Fragment>
);
